export const PHASE_STATUS = [
  { value: "not_started", label: "Not Started" },
  { value: "in_progress", label: "In Progress" },
  { value: "blocked", label: "Blocked" },
  { value: "completed", label: "Completed" },
  { value: "not_applicable", label: "Not Applicable" },
];

export const ACTION_STATUS = PHASE_STATUS.filter((s) => s.value !== "blocked");

export const PROJECT_STATUS = [
  { value: "all", label: "All statuses" },
  { value: "active", label: "Active" },
  { value: "handed_over", label: "Handed over" },
  { value: "on_hold", label: "On hold" },
];

export const PHASE_KEYS = [
  { value: "all", label: "All phases" },
  { value: "brief", label: "Brief & Kick-off" },
  { value: "technical_design", label: "Technical Design" },
  { value: "material_research", label: "Material Research" },
  { value: "supplier_quotation", label: "Supplier Quotation" },
  { value: "prototyping", label: "Prototyping" },
  { value: "costing_quotation", label: "Costing & Quotation" },
  { value: "client_confirmation", label: "Client Confirmation" },
  { value: "erp_handover", label: "ERP Handover" },
];

export const statusLabel = (s) => PHASE_STATUS.find((x) => x.value === s)?.label || s;

export const statusClass = (s) =>
  ({
    not_started: "bg-slate-100 text-slate-600 border-slate-200",
    in_progress: "bg-blue-50 text-blue-700 border-blue-200",
    blocked: "bg-red-50 text-red-700 border-red-200",
    completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
    not_applicable: "bg-amber-50 text-amber-800 border-amber-200",
  }[s] || "bg-slate-100 text-slate-600 border-slate-200");

export const EVIDENCE_LABEL = { file: "File", approval: "Approval", any: "File or approval" };

let DATE_PREF = "DD/MM/YYYY";
export const setDatePref = (p) => { if (p) DATE_PREF = p; };
const _pad = (n) => String(n).padStart(2, "0");
export const fmtDateOnly = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  const Y = d.getFullYear(), M = _pad(d.getMonth() + 1), D = _pad(d.getDate());
  if (DATE_PREF === "MM/DD/YYYY") return `${M}/${D}/${Y}`;
  if (DATE_PREF === "YYYY-MM-DD") return `${Y}-${M}-${D}`;
  return `${D}/${M}/${Y}`;
};
export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return String(iso).includes("T") ? `${fmtDateOnly(iso)} ${_pad(d.getHours())}:${_pad(d.getMinutes())}` : fmtDateOnly(iso);
};
